import { useMutation, useQueryClient } from '@tanstack/react-query'
import {
  AdminUserPaymentProfileResponse,
  updatePaymentProvider1099,
  UpdatePaymentProvider1099Options,
} from 'api/payments'

/**
 * Override a user's 1099 payment provider (Stripe vs Highnote).
 * Optimistically updates the cached user payment profile.
 */
export function useUpdatePaymentProvider1099() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (filters: UpdatePaymentProvider1099Options) =>
      updatePaymentProvider1099(filters),
    onMutate: async (filters) => {
      await queryClient.cancelQueries({
        queryKey: ['userPaymentProfile', filters.userId.toString()],
      })

      const previousProfile =
        queryClient.getQueryData<AdminUserPaymentProfileResponse>([
          'userPaymentProfile',
          filters.userId.toString(),
        ])

      queryClient.setQueryData<AdminUserPaymentProfileResponse>(
        ['userPaymentProfile', filters.userId.toString()],
        (old) => {
          if (!old) return old
          return {
            ...old,
            current1099PaymentProvider: filters.paymentProvider1099,
          }
        }
      )

      return { previousProfile }
    },
    onError: (error, filters, context) => {
      if (context?.previousProfile) {
        queryClient.setQueryData(
          ['userPaymentProfile', filters.userId.toString()],
          context.previousProfile
        )
      }
    },
    onSettled: (data, error, filters) => {
      queryClient.invalidateQueries({
        queryKey: ['userPaymentProfile', filters.userId.toString()],
      })
    },
  })
}
